import { render, staticRenderFns } from "./province-city-area.vue?vue&type=template&id=1f840f16&scoped=true&"
import script from "./province-city-area.vue?vue&type=script&lang=js&"
export * from "./province-city-area.vue?vue&type=script&lang=js&"
import style0 from "./province-city-area.vue?vue&type=style&index=0&id=1f840f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f840f16",
  null
  
)

export default component.exports